// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__3F_BS","rootSuccess":"CompleteLink_rootSuccess__2S6KV","rootFailure":"CompleteLink_rootFailure__1RsM7","isDisabled":"CompleteLink_isDisabled__2zrCm"};